import * as React from 'react'

import { Separator } from '@thg-commerce/gravity-elements'
import { styled, spacing } from '@thg-commerce/gravity-theme'

export interface DisclaimerProps {
  text?: string
}

const StyledSeparator = styled(Separator)`
  margin: ${spacing(2)} 0;
`

const StyledDisclaimerText = styled.p`
  text-align: center;
`

export const Disclaimer = (props: DisclaimerProps) => {
  return props.text ? (
    <React.Fragment>
      <StyledSeparator />
      <StyledDisclaimerText data-testid="article-disclaimer">
        {props.text}
      </StyledDisclaimerText>
    </React.Fragment>
  ) : null
}
